module.exports = __webpack_public_path__ + "static/media/trash-outlined.92b099c4.png";